import { createSelector } from 'reselect';

// types
import IRootState from 'models/IRootState';

export const isLoadingSelector = createSelector(
  (state: IRootState) => state.app,
  (app) => app.isLoading,
);

export const dialogSelector = createSelector(
  (state: IRootState) => state.app,
  (app) => app.dialog,
);

export const appheaderSelector = createSelector(
  (state: IRootState) => state.app,
  (app) => ({
    header:app.header,
    isNavEnlarged:app.isNavEnlarged
  }),
)

export const breadcrumbSelector = createSelector(
  (state: IRootState) => state.app,
  (app) => app.breadcrumbs,
)

export const notificationsSelector = createSelector(
  (state: IRootState) => state.app,
  (app) => app.notifications,
);

export const alertSelector = createSelector(
  (state: IRootState) => state.app,
  (app) => app.alert,
);

